import type { MouseEvent } from "react"
import { EditorContent } from "@tiptap/react"
import { Editor } from "@tiptap/react"

type EditorContentAreaProps = {
  editor: Editor | null
  height?: string | number
}

const EditorContentArea = ({ editor, height = 400 }: EditorContentAreaProps) => {
  const resolvedHeight =
    typeof height === "number" ? `${height}px` : height

  const focusIfEmptySpace = (event: MouseEvent<HTMLDivElement>) => {
    if (!editor || editor.isDestroyed || !editor.isEditable) return
    const target = event.target as HTMLElement
    if (target.closest(".ProseMirror")) return
    event.preventDefault()
    editor.chain().focus("end").run()
  }

  return (
    <div
      className='tiptap-editor__content'
      style={{
        minHeight: resolvedHeight,
        ["--tiptap-content-min-height" as string]: resolvedHeight,
      }}
      onMouseDown={focusIfEmptySpace}
    >
      <EditorContent editor={editor} />
    </div>
  )
}

export default EditorContentArea
